export class Company {
  constructor(
    private id: CompanyId,
    public name: string,
    public tin: string
  ) { }

  public getId(): CompanyId {
    return this.id;
  }
}

export type CompanyId = string;



// WEBPACK FOOTER //
// /dist/src/app/user/work-record/company.model.ts